import React from 'react';

const Page403 = () => {
  return (
    <div className='flex items-center justify-center h-full flex-col'>
      <h1>403</h1>
      <p>Sorry, you are not authorized to access this page.</p>
    </div>
  );
};

export default Page403;
